import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validateCadastrar from "./form-validate-cadastrar";
import validateEditar from "./form-validate-editar";

const VendedorCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    imagem: "",
    nome: "",
    telefone: "",
    email: "",
    ativo: true,
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-vendedor").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append("id", state.id);
      formData.append("imagem", state.imagem);
      formData.append("nome", state.nome);
      formData.append("telefone", state.telefone);
      formData.append("email", state.email);
      formData.append("ativo", state.ativo);

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/vendedor", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/vendedor");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o vendedor.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/vendedor/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [vendedor] = await Promise.all([carregarDados()]);

        if (vendedor) {
          setState(vendedor);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do vendedor");
      }
    };

    let validacao = window
      .$("#form-vendedor")
      .validate(!location.state ? validateCadastrar : validateEditar);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Vendedores"
        header="Cadastro do Vendedor"
        action={{ titulo: "Voltar", link: "/vendedor" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do vendedor</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-vendedor">
                      <div className="row">
                        <div className="col-lg-5">
                          <div className="form-group">
                            <label>Imagem do vendedor</label>
                            <input
                              type="file"
                              placeholder="Imagem do vendedor"
                              className="form-control"
                              name="imagem"
                              accept="image/*"
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  imagem: e.target.files[0],
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-5">
                          <div className="form-group">
                            <label>Nome do vendedor</label>
                            <input
                              type="text"
                              placeholder="Nome do vendedor"
                              className="form-control"
                              name="nome"
                              value={state.nome}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label>Status do vendedor</label>
                            <select
                              className="form-control"
                              id="ativo"
                              name="ativo"
                              value={state.ativo}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="1" value={true}>
                                Ativo
                              </option>

                              <option key="2" value={false}>
                                Inativo
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-8">
                          <div className="form-group">
                            <label>Email do vendedor</label>
                            <input
                              type="text"
                              placeholder="Email do vendedor"
                              className="form-control"
                              name="email"
                              value={state.email}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Telefone do vendedor</label>
                            <input
                              type="text"
                              placeholder="Telefone do vendedor"
                              className="form-control"
                              name="telefone"
                              value={state.telefone}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default VendedorCadastrar;
